import React, { useEffect, useState } from "react";
import { Modal, Radio, Space, Typography } from "antd";
import { roleNames } from "../../constant";
import PrimaryButton from "../Forms/PrimaryButton";

const { Text, Title } = Typography;

/**
 * ChangeRole modal
 *
 * Props:
 * - isOpen: boolean
 * - closeModal: () => void
 * - data: object (user record). component will try to read current role from data.role_id or data.role
 * - onConfirm: (selectedRole, data) => Promise|void
 * - loading: boolean (shows confirm loading)
 * - roleOptions?: Array<{ id: string|number, label: string, description?: string }>
 *
 * By default roleOptions = [
 *   { id: "admin", label: "Admin" },
 *   { id: "sales", label: "Salesperson" },
 *   { id: "customer", label: "Customer" }
 * ]
 */
const DEFAULT_ROLES = Object.entries(roleNames)
  .filter(([id, _]) => id !== "2" && id !== "1")
  .map(([value, label]) => ({ value: Number(value), label }));

const ChangeRole = ({
  isOpen,
  closeModal,
  data = {},
  onConfirm,
  loading = false,
  roleOptions = DEFAULT_ROLES,
}) => {
  // try to detect current role from common fields
  const initialRole = data?.role_id ?? null;

  const [selectedRole, setSelectedRole] = useState(initialRole ?? roleOptions[0].id);

  useEffect(() => {
    // when modal opens or data changes, sync selected role
    const detected = data?.role_id ?? null;
    setSelectedRole(detected ?? (roleOptions[0] && roleOptions[0].id));
  }, [isOpen, data, roleOptions]);

  const handleConfirm = async () => {
    if (typeof onConfirm === "function") {
      await onConfirm(selectedRole, data);
    }
  };

  return (
    <Modal
      open={!!isOpen}
      centered
      title={
        <Title level={2} className="font-abhaya !mb-0">
          Change Role
        </Title>
      }
      onCancel={closeModal}
      destroyOnHidden
      width={300}
      footer={null}
      className="form-css-5"
    >
      <div>
        {data?.full_name && (
          <Text className="w-full text-left text-base mt-2 mb-4">
            Changing role for <strong>{data.full_name}</strong>:
          </Text>
        )}

        <Radio.Group
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
          style={{ width: "100%" }}
          className="mt-4"
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            {roleOptions.map((role) => (
              <Radio key={role.value} value={role.value}>
                {role.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>

        <div className="w-full flex justify-center mt-4">
          <PrimaryButton
            text={"Confirm"}
            onClick={handleConfirm}
            loading={loading}
            className="me-[30px]"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ChangeRole;
